const colorTranslate: Record<string, string> = {
  'COLOR.YELLOW': 'Amarillo',
  'COLOR.BLUE': 'Azul',
  'COLOR.BEIGE': 'Beige',
  'COLOR.WHITE': 'Blanco',
  'COLOR.GOLD': 'Dorado',
  'COLOR.GRAY': 'Gris',
  'COLOR.BROWN': 'Marrón',
  'COLOR.ORANGE': 'Naranja',
  'COLOR.BLACK': 'Negro',
  'COLOR.RED': 'Rojo',
  'COLOR.PINK': 'Rosa',
  'COLOR.GREEN': 'Verde',
  'COLOR.SILVER': 'Plata / Plateado', // New silver color with frontend display
}

export default colorTranslate
